import _ from 'lodash';
import { updateMethodTypeConfig } from '../../apis/shop.service';
import {
  ERROR_UPDATE_CONFIG,
  ERROR_WRONG_INFORMATIONS,
  ORDER_TYPES,
  PAYMENTS_TYPES,
  SALES_TYPES,
  SALES_TYPE_ROUTE,
  SUCCESS_UPDATE_TEXT,
  PAYMENT_TYPE_STRIPE
} from '../../constants';
import { sendCloudWatchAlert } from '../../utils/applicationError';
import { showNotification } from '../Notification/Notification.view';
export const getDeliveryPaymentType = (delivery, shopDelivery, isAllShops) => {
  let deliveryPayementType = delivery?.paymentTypes || []
  if (!isAllShops && shopDelivery?.paymentTypes) {
    deliveryPayementType = shopDelivery.paymentTypes || []
  }
  return deliveryPayementType
}
export const initDataConfig = async (newProps, component) => {
  const {
    configurations, //shop obj
    terminal,
    mobileApp,
    qrcode,
    webapp,
    location,
    isAllShops,
    paymentTypes: generalPaymentTypes,
    orderTypes: generalOrderTypes,
    delivery = {}
  } = newProps;
  const { configuration = {} } = configurations; //shop config
  let matched = false;
  const { pathname } = location;
  if (pathname === SALES_TYPE_ROUTE) {
    matched = true;
  }
  const {
    orderTypes = generalOrderTypes,
    refs = {},
    paymentTypes = generalPaymentTypes,
    delivery: shopDelivery
  } = configuration;
  const deliveryPaymentTypes = getDeliveryPaymentType(delivery, shopDelivery, isAllShops)
  const techs = {
    'Commande à distance': mobileApp.enabled || webapp.enabled,
    'Borne': terminal.enabled,
    'QR Code': qrcode.enabled
  };
  await component.setState({
    type: matched ? SALES_TYPES : PAYMENTS_TYPES,
    methodTypesRef: matched ? refs.orderTypes : refs.paymentTypes,
    checkedMethodTypes: matched
      ? {
        'Commande à distance': isAllShops ? generalOrderTypes : orderTypes,
        'Borne': ORDER_TYPES.Borne,
        'QR Code': ORDER_TYPES['QR Code']
      }
      : {
        'Commande à distance': isAllShops ? generalPaymentTypes : paymentTypes,
        'Borne': terminal.paymentTypes || [],
        'QR Code': qrcode.paymentTypes || []
      },
    techs,
    checkedDeliveryTypes: {
      'Commande à distance':
        deliveryPaymentTypes?.indexOf(PAYMENT_TYPE_STRIPE) > -1
          ? deliveryPaymentTypes
          : _.concat(deliveryPaymentTypes, [PAYMENT_TYPE_STRIPE])
    }
  });
};

export const handleToggle = (value, tech, type, component) => () => {
  const toCheck = 'checkedMethodTypes';
  component.setState(prevState => {
    const objectCheck = prevState[toCheck];
    const checked = objectCheck[tech];
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else if (checked.length > 1) {
      newChecked.splice(currentIndex, 1);
    }
    return { [toCheck]: { ...objectCheck, [tech]: _.filter(newChecked, item => item) } };
  });
};

export const handleToggleDeliveryType = (value, tech, component) => () => {
  const toCheck = 'checkedDeliveryTypes';
  component.setState(prevState => {
    const objectCheck = prevState[toCheck];
    const checked = objectCheck[tech] || [];
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else if (checked.length > 1) {
      newChecked.splice(currentIndex, 1);
    }
    return { [toCheck]: { ...objectCheck, [tech]: _.filter(newChecked, item => item) } };
  });
};

export const handleSubmitData = async (e, type, component) => {
  const { openErrorModal, orderTypes } = component.props;

  const { methodTypesRef, checkedMethodTypes, checkedDeliveryTypes } = component.state;
  // const methodTypeRef = type === ORDER_TYPE ? orderTypesRef : paymentTypesRef;
  // const SUITABLE_METHOD_TYPES = type === ORDER_TYPE ? SUITABLE_ORDER_TYPES : SUITABLE_PAYMENT_TYPES;

  // const isValid =
  //   !hasIntegrationEnabled() ||
  //   (_.size(methodTypeRef) === _.size(SUITABLE_METHOD_TYPES) &&
  //     (!hasIntegrationEnabled() || !_.find(methodTypeRef, method => !isStringNotNull(method.ref))));
  const isValid = true;
  try {
    component.setState({ isLoading: true });
    e.preventDefault();
    e.stopPropagation();
    if (!isValid) openErrorModal(ERROR_WRONG_INFORMATIONS);
    else {
      let dataToFirebase = {
        paymentTypes: checkedMethodTypes,
        paymentTypesRef: methodTypesRef || {},
        checkedDeliveryTypes
      };
      if (type === SALES_TYPES) {
        dataToFirebase = {
          orderTypes: checkedMethodTypes,
          orderTypesRef: methodTypesRef || {},
          generalOrderTypes: orderTypes
        };
      }
      await updateMethodTypeConfig(dataToFirebase);
      showNotification(
        'light',
        'ltr',
        'primary',
        SUCCESS_UPDATE_TEXT,
        `Les modes de ${type === SALES_TYPES ? 'vente' : 'paiement'} ont bien été modifiés.`
      );
    }
  } catch (error) {
    sendCloudWatchAlert(`Error changing ${type} method configuration ${error}`);
    openErrorModal(ERROR_UPDATE_CONFIG);
  }
  component.setState({ isLoading: false });
};

export const handleChangeInput = (key, event, component) => {
  const { methodTypesRef } = component.state;
  const { value, id } = event.target;
  component.setState({
    [id]: { ...methodTypesRef, [key]: { key, ref: value } }
  });
};
